module.exports = __webpack_public_path__ + "static/media/gts14.0a96f9a3.png";